import { effect, inject, Injectable, signal } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationService {
  private static readonly IMPERSONATION_KEY = 'impersonation';

  private readonly localStorageService = inject(LocalStorageService);
  readonly activeImpersonationDriverLoginEmail = signal<string | null>(this.get());

  constructor() {
    effect(() => {
      Sentry.getGlobalScope().setTag('impersonating', this.activeImpersonationDriverLoginEmail() ?? undefined);
    });
  }

  private get(): string | null {
    return this.localStorageService.get(ImpersonationService.IMPERSONATION_KEY);
  }

  set(driverLoginEmail: string | null) {
    if (driverLoginEmail) {
      Sentry.captureMessage(`Admin is impersonating as driver: ${driverLoginEmail}`, 'warning');
    }
    this.activeImpersonationDriverLoginEmail.set(driverLoginEmail);
    this.localStorageService.set(ImpersonationService.IMPERSONATION_KEY, driverLoginEmail);
  }

  clear() {
    this.activeImpersonationDriverLoginEmail.set(null);
    this.localStorageService.delete(ImpersonationService.IMPERSONATION_KEY);
  }
}
